var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"md":_vm.md,"cols":"12"}},[_c('v-autocomplete',_vm._b({attrs:{"value":_vm.value,"items":_vm.items},on:{"input":_vm.input}},'v-autocomplete',[_vm.$props, _vm.$attrs],false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }